export enum TemplateTypeEnum {
    BOCA = 'BOCA',
    A4 = 'A4',
    PVCCARD = 'PVCCARD'
}

